import React from "react";
import NavBar from "../components/nav";
import Breadcrums from "../components/breadcrums";
import Comments from "../components/comments";
import Footer from "../components/footer";
import Recommended from "../components/recommended";
import Blogs from "../components/blogs";

const BreatheLife = () => {
  return (
    <div className="w-full ">
      <NavBar />
      <Breadcrums />
      <div className="flex py-3 max-w-6xl mx-auto gap-3">
        <div className="md:px-0 px-6 md:w-[80%] w-full">
          <Blogs />
        </div>
        <div className="relative md:block hidden">
          <Recommended />
        </div>
      </div>
      <Comments />
      <Footer />
    </div>
  );
};

export default BreatheLife;
